import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseConsultNotesComponent } from 'app/consult-notes/pages/base-consult-notes/base-consult-notes.component';
import { PagedConsultNoteQueueResults } from 'app/core/services/consult-note-queue.service';
import { switchMap, tap } from 'rxjs/operators';
import { UserStatsComponent } from '../../components/user-stats/user-stats.component';

import { ConsultNoteQueueAssignUserComponent } from '../../../shared/components/consult-note-queue-assign-user/consult-note-queue-assign-user.component';
import { ConsultNoteQueueResultsComponent } from '../../../shared/components/consult-note-queue-results/consult-note-queue-results.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-capture-admin-my-consult-notes',
  templateUrl: './capture-admin-my-consult-notes.component.html',
  styleUrls: ['./capture-admin-my-consult-notes.component.scss'],
  imports: [UserStatsComponent,
    ConsultNoteQueueAssignUserComponent,
    ConsultNoteQueueResultsComponent,
    MatProgressSpinner]
})
export class CaptureAdminMyConsultNotesComponent extends BaseConsultNotesComponent implements OnInit, OnDestroy {
  resultCount = 0;

  ngOnInit() {
    this.init();
    this.loadResultCount();
  }

  protected configureGetResults() {
    this.getResults$
      .pipe(
        tap(() => {
          this.loadingResults = true;
          this.consultNoteQueueResults = [];
          this.userPresenceService.unsubscribeAll();
        }),
        switchMap(
          () => this.consultNoteQueueService.getMyResults(this.authenticationService.currentUser.id, this.cursor)
        )
      )
      .subscribe((results: PagedConsultNoteQueueResults) => {
        this.consultNoteQueueResults = results.consultNoteQueueResults;
        this.cursor = results.meta.cursor;
        this.loadingResults = false;
        this.hasMoreResults = !!results.meta.cursor;
        this.subscribeToUserPresence();
      });
  }

  protected startTimeTracking() {
    const data: any = { page: 'my_consult_note_queue' };
    this.userTimingService.track(data);
  }

  private loadResultCount() {
    this.consultNoteQueueService.getMyCount(this.authenticationService.currentUser?.id).subscribe((result) => {
      this.resultCount = result.count;
    });
  }
}
